<template>
  <div class="mb-16">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{
        $t(
          'message.publishDocuments.configGenericPublish.inputDocumentType.question'
        )
      }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{
        $t(
          'message.publishDocuments.configGenericPublish.inputDocumentType.description'
        )
      }}
    </p>
    <zt-input
      ref="ztInputMultiSelect"
      v-model="documentSelectedName"
      outlined
      clearable
      :label="
        $t(
          'message.publishDocuments.configGenericPublish.inputDocumentType.label'
        )
      "
      append-icon="caret-down"
      :key="renderKeyMultiselect"
      @click="openMultiselect"
      @blur="closeMultiselect"
      @clear="onClear"
      @keyup="search"
      data-vs-input="input-document-type"
    />
    <MultiSelect
      ref="multiselect"
      v-model="documentSelected"
      v-validate="{
        required: true
      }"
      name="documentType"
      data-vs-select="documentType"
      :options="documents"
      :searchable="true"
      :close-on-select="true"
      :show-labels="false"
      placeholder=""
      group-values="childs"
      group-label="name"
      label="name"
      track-by="id"
      @select="selectedOptionMultiselect"
    >
      <template slot="noResult"
        ><span class="multiselect__single">{{
          $t(
            'message.publishDocuments.configGenericPublish.inputDocumentType.noDocuments'
          )
        }}</span></template
      >
      <template slot="noOptions"
        ><span class="multiselect__single">{{
          $t('message.actions.empty_list')
        }}</span></template
      >
    </MultiSelect>
    <div class="text-zt-danger" v-if="errors.has('documentType')">
      <span class="text-zt-danger">
        {{ errors.first('documentType') }}
      </span>
    </div>
    <div
      class="text-zt-info font-normal text-zt-primary-200 mt-2 flex items-center justify-start"
      v-if="signMessage"
    >
      <zt-icon
        name="exclamation-circle-outline"
        class="text-zt-warning mr-2"
        :style="{ fontSize: '2rem' }"
      />
      <span>
        {{ signMessage }}
      </span>
    </div>
  </div>
</template>

<script>
import MultiSelect from 'vue-multiselect'
export default {
  name: 'inputDocumentType',
  inject: ['statePublish', 'NotificationModalStore'],
  components: {
    MultiSelect
  },
  props: {
    documents: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      documentSelected: null,
      documentSelectedName: '',
      renderKeyMultiselect: 0
    }
  },
  computed: {
    signMessage() {
      if (!this.documentSelected) return ''
      return this.documentSelected && this.documentSelected.firmable
        ? this.$t(
            'message.publishDocuments.configGenericPublish.sign.required'
          )
        : this.$t(
            'message.publishDocuments.configGenericPublish.sign.notRequired'
          )
    }
  },
  methods: {
    openMultiselect() {
      this.$refs.multiselect.activate()
    },
    closeMultiselect() {
      this.$refs.multiselect.deactivate()
    },
    selectedOptionMultiselect(option) {
      this.documentSelectedName = option.name
      this.documentSelected = option
      this.selectCertificate(option.id)
      this.renderKeyMultiselect++
      this.statePublish.documentType = option
      this.NotificationModalStore.docName = option.name
      if (!this.documentSelected.firmable) {
        this.statePublish.documentSignature = false
      }
    },
    onClear() {
      this.documentSelectedName = ''
      this.documentSelected = null
      this.renderKeyMultiselect++
      this.statePublish.documentType = null
      this.statePublish.documentUrl = ''
      this.NotificationModalStore.docName = ''
    },
    onReset() {
      this.onClear()
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },
    search() {
      this.$refs.multiselect.search = this.documentSelectedName
    },
    selectCertificate(id) {
      const documentFolder = this.documents.find(document =>
        document.childs.some(item => item.id === id)
      )
      this.statePublish.documentUrl = `/folder/${documentFolder.id}/subfolder/${id}`
    }
  }
}
</script>

<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
::v-deep .multiselect__content-wrapper::-webkit-scrollbar-track {
  background-color: #c4c4c4;
}
::v-deep .multiselect__content-wrapper::-webkit-scrollbar {
  width: 0.625rem;
}
::v-deep .multiselect__content-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #888888;
}
::v-deep .multiselect__content-wrapper {
  width: fit-content;
  min-width: 100%;
  border: solid 1px rgba(0, 0, 0, 0.12);
  border-radius: 3px;
}

::v-deep .multiselect__tags {
  border: none;
  padding: 8px 38px 0 0;
  display: none;
}

::v-deep .multiselect__select {
  padding-left: 16px;
  display: none;
}

::v-deep .multiselect__option {
  padding-left: 2rem;
}
::v-deep .multiselect__option--group {
  background: transparent;
  font-weight: bold;
  padding: 1rem;
}
::v-deep .multiselect__option--selected,
::v-deep .multiselect__option--highlight {
  background-color: #e7e8ff !important;
  color: #707070;
  font-weight: normal;
}
::v-deep .multiselect__option span {
  max-width: 530px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .zt-input-appended-icon {
  order: 4;
}
</style>
